// extracted by mini-css-extract-plugin
export default {"tabSelectBox":"VendorPopup-desktop_tabSelectBox__rirCI"};